import React from "react";
import "./AviatorCard.css";
import { Link } from "react-router-dom";

const AviatorCard = ({
  badgeTitle,
  introText,
  mainTitle,
  bodyText,
  linkUrl,
  linkText,
}) => {
  return (
    <div className="aviator-card-wrapper">
      <div className="aviator-card">
        {/* Top Metallic Header Badge */}
        <div className="card-header-badge">
          {/* <span>{badgeTitle}</span> */}
        </div>

        {/* Card Body Content */}
        <div className="card-body">
          <p className="intro-text">{introText}</p>

          <h1 className="main-title">{mainTitle}</h1>
          <div>
            <p className="body-text">{bodyText}</p>

            <span
              // to={linkUrl}
              // target="_blank"
              rel="noopener noreferrer"
              className="aviator-link"
            >
              <span className="linkText">{linkText}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AviatorCard;
